<template>
    <div class="gz-breadcrumbs">
        <span @click="$router.go(-1)">назад</span>
        &nbsp;/&nbsp;
        <span>{{ currentPageName }}</span>
    </div>
</template>

<script>
export default {
    name: 'Breadcrumbs',

    computed: {
        currentPageName() {
            return this.$route.meta.name
        }
    }
}
</script>